var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHighlightedCardCorner = function SvgHighlightedCardCorner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    fill: "none",
    viewBox: "0 0 74 74"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M73.49 1.23A1.99 1.99 0 0 0 71.64 0H11.92C5.35 0 0 5.35 0 11.92v59.72c0 .81.49 1.54 1.23 1.85.25.1.51.15.76.15.52 0 1.03-.2 1.41-.59L73.05 3.41a2 2 0 0 0 .43-2.18z"
  })));
};
export default SvgHighlightedCardCorner;